__turbopack_context__.v({
  "actions": "sports-site-chrome-module__A7f62a__actions",
  "announcement": "sports-site-chrome-module__A7f62a__announcement",
  "brand": "sports-site-chrome-module__A7f62a__brand",
  "childGroup": "sports-site-chrome-module__A7f62a__childGroup",
  "childGroupHeading": "sports-site-chrome-module__A7f62a__childGroupHeading",
  "childLinks": "sports-site-chrome-module__A7f62a__childLinks",
  "dropPanel": "sports-site-chrome-module__A7f62a__dropPanel",
  "footer": "sports-site-chrome-module__A7f62a__footer",
  "footerBottom": "sports-site-chrome-module__A7f62a__footerBottom",
  "footerBrand": "sports-site-chrome-module__A7f62a__footerBrand",
  "footerContactStrip": "sports-site-chrome-module__A7f62a__footerContactStrip",
  "footerDisclaimer": "sports-site-chrome-module__A7f62a__footerDisclaimer",
  "footerGroup": "sports-site-chrome-module__A7f62a__footerGroup",
  "footerGroups": "sports-site-chrome-module__A7f62a__footerGroups",
  "footerHeading": "sports-site-chrome-module__A7f62a__footerHeading",
  "footerInner": "sports-site-chrome-module__A7f62a__footerInner",
  "footerLocation": "sports-site-chrome-module__A7f62a__footerLocation",
  "footerLocationContact": "sports-site-chrome-module__A7f62a__footerLocationContact",
  "footerLocations": "sports-site-chrome-module__A7f62a__footerLocations",
  "footerPromo": "sports-site-chrome-module__A7f62a__footerPromo",
  "footerPromoImage": "sports-site-chrome-module__A7f62a__footerPromoImage",
  "footerTagline": "sports-site-chrome-module__A7f62a__footerTagline",
  "groupOverview": "sports-site-chrome-module__A7f62a__groupOverview",
  "groupTrigger": "sports-site-chrome-module__A7f62a__groupTrigger",
  "header": "sports-site-chrome-module__A7f62a__header",
  "headerRow": "sports-site-chrome-module__A7f62a__headerRow",
  "locationMinus": "sports-site-chrome-module__A7f62a__locationMinus",
  "locationPlus": "sports-site-chrome-module__A7f62a__locationPlus",
  "logo": "sports-site-chrome-module__A7f62a__logo",
  "menuToggle": "sports-site-chrome-module__A7f62a__menuToggle",
  "mobilePrimaryAction": "sports-site-chrome-module__A7f62a__mobilePrimaryAction",
  "navItem": "sports-site-chrome-module__A7f62a__navItem",
  "navLink": "sports-site-chrome-module__A7f62a__navLink",
  "navigation": "sports-site-chrome-module__A7f62a__navigation",
  "primaryAction": "sports-site-chrome-module__A7f62a__primaryAction",
  "socials": "sports-site-chrome-module__A7f62a__socials",
  "sr-only": "sports-site-chrome-module__A7f62a__sr-only",
  "venueSwitcher": "sports-site-chrome-module__A7f62a__venueSwitcher",
});
